export enum ReleaseScheduleActionProperties {
  Name = 'name',
  SeasonId = 'seasonId',
  ReleaseZone = 'releaseZone',
  ReleaseDate = 'releaseDate',
  ReleaseType = 'releaseType',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  MediaId = 'mediaId',
  Executed = 'executed',
  SeriesId = 'seriesId',
  ReleaseActionType = 'releaseActionType',
  ReleaseState = 'releaseState',
  Enabled = 'enabled',
  CuratedSeriesListId = 'curatedSeriesListId',
  SystemOwned = 'systemOwned',
  CuratedMediaListId = 'curatedMediaListId',
  CoherentScreenId = 'coherentScreenId',
}
export enum ReleaseScheduleActionMetaProperties {
  ReleaseZoneId = 'ReleaseZone-id',
  ReleaseZoneVersion = 'ReleaseZone-version',
}
